import React from "react";

export type FolderTabKey = "everything" | "pages" | "links" | "documents";

export interface FolderTabCounts {
    pages: number;
    links: number;
    documents: number;
}

interface Props {
    active: FolderTabKey;
    counts: FolderTabCounts;
    onChange: (key: FolderTabKey) => void;
}

const TABS: { key: FolderTabKey; label: string }[] = [
    { key: "everything", label: "Everything" },
    { key: "pages", label: "Pages" },
    { key: "links", label: "Links" },
    { key: "documents", label: "Documents" },
];

export default function FolderTabs({ active, counts, onChange }: Props) {
    const everything = counts.pages + counts.links + counts.documents;

    function countFor(key: FolderTabKey): number {
        if (key === "everything") return everything;
        return counts[key];
    }

    return (
        <div className="m-cat-tabs">
            {TABS.map(t => (
                <button
                    key={t.key}
                    type="button"
                    className={"m-cat-tab" + (active === t.key ? " active" : "")}
                    onClick={() => onChange(t.key)}
                >
                    <span>{t.label}</span>
                    <span className="m-cat-tab-count">{countFor(t.key)}</span>
                </button>
            ))}
        </div>
    );
}
